import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ButtonLoading, FormCheck } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormDirty } from "go-form/components/FormDirty";
import { organizationApi } from "../../../services/Api/Organization/organizationApi";
import { AcceptOrganizationTermsSecurityApi } from "../../../services/Api/types";
import { useAuth } from "../../../services/Security/auth";
import { selectOrganization } from "../../../services/organizations/selectors";
import { OrganizationActionTypes } from "../../../services/organizations/types";

const SecurityOrganizationAcceptTerms = () => {
	const [loading, setLoading] = useState(false);
	const { addFlash } = useFlash();
	const auth = useAuth();
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const form = useForm<AcceptOrganizationTermsSecurityApi>({
		criteriaMode: "all",
	});
	const organization = useSelector(selectOrganization);
	const {
		register,
		handleSubmit,
		formState: { errors },
		setError,
		setValue,
	} = form;

	const onSubmit = handleSubmit(async (data) => {
		setLoading(true);
		try {
			if (data.accept_terms) {
				setValue("accept_privacy", true);
				setValue("accept_rules", true);
			}
			const res = await organizationApi.acceptOrganizationTerms(data);
			await auth.checkLogin();
			dispatch({ type: OrganizationActionTypes.SET, payload: res.data.data });
		} catch (e) {
			handleError.form(e, setError, addFlash);
		}
		setLoading(false);
	});

	const renderButtons = () => {
		return (
			<>
				<ButtonLoading loading={loading} type="submit">
					{t("lib:common.action.accept")}
				</ButtonLoading>
			</>
		);
	};

	return (
		<div className="container-fluid mt-2">
			<div className="col-6">
				<h5>{t("modules.security.field.organization_accept_terms.title", { name: organization.name })}</h5>
				<FormDirty
					buttonSubmitCustom={renderButtons()}
					isDirty={false}
					errors={errors}
					loading={loading}
					noValidate
					onSubmit={onSubmit}
				>
					<FormCheck
						name={"accept_terms"}
						errors={errors}
						register={register}
						label={
							<>
								{t("lib:go_security.register.words.accept")}
								<a href="https://www.gopos.pl/tos">{t("lib:go_security.register.words.tos")}</a>,{" "}
								<a href="https://www.gopos.pl/privacy-policy">
									{t("lib:go_security.register.words.privacy_policy")}
								</a>{" "}
								{t("lib:go_security.register.words.and_accept_receive_informations_from_gopos")}
							</>
						}
					/>
					<FormCheck
						name="support_access"
						errors={errors}
						register={register}
						defaultChecked
						label={t("lib:go_security.register.words.support_access")}
					/>
				</FormDirty>
				<a target="_blank" href={`/profile/remove_account`} rel="noreferrer">
					{t("lib:go_security.actions.remove_account")}
				</a>
			</div>
		</div>
	);
};

export default SecurityOrganizationAcceptTerms;
